import request from "@/utils/request";
const baseUrl = process.env.VUE_APP_APP_API + "/web/investment";

const zsyzApi = {
  // 列表
  page(params) {
    return request({
      url: `${baseUrl}/page`,
      method: "GET",
      params
    });
  },
  type(params) {
    return request({
      url: `${baseUrl}/getAttractTypelist`,
      method: "GET",
      params
    });
  }
};

export default zsyzApi;
